import styled from 'styled-components';

/* && dobra a classe (0,0,2,0) para vencer o `td button` do DataTable (0,0,1,2),
   que sublinha e pinta de laranja os botoes de texto das celulas */
export const Button = styled.button`
  && {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    width: 32px;
    height: 32px;
    padding: 0;
    margin: 0 2px;

    border: none;
    border-radius: 4px;
    background: transparent;
    color: ${({ theme }) => theme.colors.gray[600]};

    cursor: pointer;
    text-decoration: none;
    transition: background-color 0.15s, color 0.15s;

    svg {
      width: 18px;
      height: 18px;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.06);
      color: ${({ theme }) => theme.colors.orange.primary};
      filter: none;
    }

    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.colors.orange.primary};
      outline-offset: 1px;
    }
  }
`;
